<template>
  <div>
    <b-overlay :show="loading" rounded="sm">
      <ul class="activity">
        <li
          class="activity-item"
          :class="``"
          v-for="(c, i) in columns"
          :key="i"
        >
          <div
            class="activity-icon"
            :class="
              c.id == task.column.id
                ? 'bg-success-light tx-success'
                : 'bg-light-light tx-light'
            "
          >
            {{ i + 1 }}
          </div>
          <div class="activity-body">
            <div>{{ c.column }}</div>
            <div
              v-for="(t, i) in transfers.filter(x => x.toColumnId == c.id)"
              :key="i"
              class="tx-12 tx-color-03"
            >
              {{ t.date | moment("dddd, MM-р сарын DD HH:mm") }}
            </div>
            <ul
              class="list-unstyled media-list mg-b-15"
              v-if="c.id == task.column.id"
            >
              <li
                class="media align-items-center"
                v-for="(u, i) in users"
                :key="i"
              >
                <a href=""
                  ><div
                    :class="`avatar avatar-${u.isDone ? 'online' : 'offline'}`"
                  >
                    <img :src="u.avator" class="rounded-circle" alt="" /></div
                ></a>
                <div class="media-body pd-l-15">
                  <p class="tx-medium mg-b-2">
                    <a href="" class="link-01">{{ u.displayName }}</a>
                  </p>
                  <span class="tx-12 tx-color-03">{{
                    u.isSeen ? u + "үзсэн" : ""
                  }}</span>
                  <span v-if="u.isDone"
                    ><feather class="wd-16 ht-16" type="check-square"></feather
                    >Дууссан</span
                  >
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </b-overlay>
  </div>
</template>

<script>
// import { taskInheritedDetail } from "@/api/task";

export default {
  props: {
    task: {
      type: Object,
      default: () => 0
    },
    columns: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    },
    transfers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // obj:{
      //     data:{
      //         columns: [],
      //         pinnedUsers: [],
      //     }
      // },
      loading: false
    };
  },
  mounted() {
    // this.loading= true;
    // taskInheritedDetail({
    //     params: { id: this.id },
    //     store: this.$store
    // }).then(res => {
    //     this.loading= false;
    //     this.obj= res;
    //     console.log(res);
    // });
  },
  methods: {}
};
</script>

<style></style>
